/* eslint-disable react/destructuring-assignment */
import React, { PureComponent } from 'react';
import { bool, func, node, string } from 'prop-types';

import logger from '@/utils/logger';

const styErrorContainer = {
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

class ErrorBoundary extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  componentDidCatch(error, info) {
    const { debug, source } = this.props;

    if (debug) {
      console.groupCollapsed('Error occured!');
      console.error(`
        [ErrorBoundary] Source of Error: ${source}
        [ErrorBoundary] Error message: ${error.message}
        [ErrorBoundary] Error stack: ${error.stack}
        [ErrorBoundary] Component stack: ${info.componentStack}
      `);
      console.groupEnd();
    }

    logger.sendNrNotice(error, { ...info, identifier: 'RENDER_ERROR' });
    this.setState({ hasError: true });
  }

  defaultRender = () => {
    const message = this.props.errorMessage || 'Sorry, something went wrong.';
    return <div style={styErrorContainer}>{message}</div>;
  };

  render() {
    if (this.state.hasError) {
      return this.props.render ? this.props.render() : this.defaultRender();
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: node,
  debug: bool,
  errorMessage: string,
  render: func,
  source: string,
};

ErrorBoundary.defaultProps = {
  children: null,
  debug: true,
  errorMessage: '',
  render: null,
  source: 'app',
};

export default ErrorBoundary;
